// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"763d0ac9","942":"ccdb0bf1"}[chunkId] + ".css";
};